import { render } from "./Chart1.vue?vue&type=template&id=ef3d2cb2&scoped=true"
import script from "./Chart1.vue?vue&type=script&lang=js"
export * from "./Chart1.vue?vue&type=script&lang=js"

import "./Chart1.vue?vue&type=style&index=0&id=ef3d2cb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3d2cb2"]])

export default __exports__